/* ElitePetToys - Versandhinweise im Frontend, gestaffelt nach Bestellwert.

   Hintergrund: Die Versandsaetze stehen an mehreren Stellen fest verdrahtet
   im Theme - in der Warenkorb-Schublade und in der Versandzeile der
   Produktseite (templates/index.liquid bzw. templates/product.ep.liquid)
   sowie in der Ankuendigungsleiste. Die tatsaechlich berechneten Saetze
   kommen aus den Shopify-Versandeinstellungen und sind seit 09/2026:

     unter 15,00 EUR   ->  1,95 EUR
     15,00 - 49,94 EUR ->  3,95 EUR
     ab 49,95 EUR      ->  kostenlos

   (Das gilt fuer die Zone Deutschland. Die EU-Zone liegt weiterhin bei
   7,90 EUR und wird ab 79,00 EUR frei - deshalb der Zusatz "in Deutschland"
   in der Ankuendigungsleiste.)

   Dieses Skript schreibt die angezeigten Hinweise passend zum Betrag, damit
   Schublade, Produktseite und Kasse dasselbe sagen. Es rechnet nichts nach
   und veraendert nichts am Warenkorb - es schreibt nur Text.

   Wichtig: Aendert sich ein Satz in den Shopify-Versandeinstellungen,
   muessen die vier Konstanten hier direkt darunter mitgeaendert werden. */
(function () {
  var FREI_AB_CENT = 4995;
  var KLEIN_BIS_CENT = 1500; /* exklusiv: alles darunter gilt als Kleinbestellung */
  var SATZ_KLEIN = '1,95';
  var SATZ_NORMAL = '3,95';
  var FREI_AB_TEXT = '49,95 €';

  /* Langfassung fuer die Warenkorb-Schublade */
  function hinweisFuer(cent) {
    if (cent >= FREI_AB_CENT) {
      return 'Versandkostenfrei · inkl. MwSt.';
    }
    var betrag = cent < KLEIN_BIS_CENT ? SATZ_KLEIN : SATZ_NORMAL;
    return 'zzgl. ' + betrag + ' € Versand (kostenlos ab ' + FREI_AB_TEXT + ') · inkl. MwSt.';
  }

  /* Kurzfassung fuer die Versandzeile auf der Produktseite */
  function kurzhinweisFuer(cent) {
    if (cent >= FREI_AB_CENT) {
      return 'versandkostenfrei';
    }
    if (cent < KLEIN_BIS_CENT) {
      return 'Versand nur ' + SATZ_KLEIN + ' €';
    }
    return 'Versand ' + SATZ_NORMAL + ' € · gratis ab ' + FREI_AB_TEXT;
  }

  /* "12.345,67 €" -> 1234567 ; alles andere -> null */
  function centAus(text) {
    var roh = String(text || '').replace(/\s/g, '');
    var treffer = roh.match(/(\d[\d.]*),(\d{2})€?$/);
    if (!treffer) { return null; }
    var euro = parseInt(treffer[1].replace(/\./g, ''), 10);
    var cent = parseInt(treffer[2], 10);
    if (isNaN(euro) || isNaN(cent)) { return null; }
    return euro * 100 + cent;
  }

  /* Schreibt nur, wenn sich der Text wirklich aendert - sonst wuerde der
     MutationObserver sich selbst immer wieder ausloesen. */
  function setzen(el, text) {
    if (el && el.textContent !== text) { el.textContent = text; }
  }

  /* --- Warenkorb-Schublade --- */
  function drawerKorrigieren() {
    var fuss = document.getElementById('dfoot');
    if (!fuss) { return; }
    var hinweis = fuss.querySelector('.d-note');
    if (!hinweis) { return; }

    var betrag = null;
    var felder = fuss.querySelectorAll('.d-row span');
    for (var i = 0; i < felder.length; i++) {
      var wert = centAus(felder[i].textContent);
      if (wert !== null) { betrag = wert; }
    }
    if (betrag === null) { return; }

    setzen(hinweis, hinweisFuer(betrag));
  }

  /* --- Versandzeile auf der Produktseite ---
     Betrag aus angezeigtem Preis mal Menge, damit die Zeile denselben Wert
     zugrunde legt wie die Vorlage selbst. Steht dort "Nicht verfuegbar",
     liefert centAus null und wir lassen den Text in Ruhe. */
  function pdpKorrigieren() {
    var ziel = document.getElementById('pdp-ship');
    if (!ziel) { return; }
    var preisEl = document.getElementById('pdp-price');
    if (!preisEl) { return; }
    var preis = centAus(preisEl.textContent);
    if (preis === null) { return; }
    var mengeEl = document.getElementById('pdp-qty');
    var menge = parseInt((mengeEl ? mengeEl.textContent : '1') || '1', 10);
    if (isNaN(menge) || menge < 1) { menge = 1; }
    setzen(ziel, kurzhinweisFuer(preis * menge));
  }

  /* --- Ankuendigungsleiste ---
     Der sichtbare Lauftext kommt aus dem CSS (::before) und ist bereits
     aktuell. Der Text im Element selbst ist per font-size:0 unsichtbar,
     wird aber von Screenreadern und Suchmaschinen gelesen - deshalb hier
     mitziehen. In den Vorlagen steht dort noch der alte Betrag 79,00. */
  function announceKorrigieren() {
    var leisten = document.querySelectorAll('.announce');
    for (var i = 0; i < leisten.length; i++) {
      var alt = leisten[i].textContent || '';
      if (alt.indexOf('79,00') === -1) { continue; }
      leisten[i].textContent = alt.replace(/79,00\s*€/g, FREI_AB_TEXT + ' in Deutschland');
    }
  }

  function beobachten(el, rueckruf) {
    if (!el) { return; }
    try {
      new MutationObserver(rueckruf).observe(el, {
        childList: true,
        subtree: true,
        characterData: true
      });
    } catch (e) { /* aeltere Browser: dann bleibt der Ursprungstext stehen */ }
  }

  function starten() {
    announceKorrigieren();

    var fuss = document.getElementById('dfoot');
    if (fuss) {
      beobachten(fuss, drawerKorrigieren);
      drawerKorrigieren();
    }

    var ship = document.getElementById('pdp-ship');
    if (ship) {
      /* Auf die Zeile selbst hoeren (die Vorlage schreibt sie bei jedem
         Variantenwechsel neu) und zusaetzlich auf Menge und Preis. */
      beobachten(ship, pdpKorrigieren);
      beobachten(document.getElementById('pdp-qty'), pdpKorrigieren);
      beobachten(document.getElementById('pdp-price'), pdpKorrigieren);
      pdpKorrigieren();
    }

    /* Die Schublade wird erst beim ersten Oeffnen befuellt; falls sie beim
       Start noch fehlt, spaeter nochmal nachsehen. */
    if (!fuss) { window.setTimeout(starten, 400); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }
})();
